/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { NgModule } from '@angular/core';
import {
  DefaultUrlSerializer,
  RouterModule,
  Routes,
  UrlSerializer,
  UrlTree,
} from '@angular/router';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadChildren: () => import('@piqet-angular/features').then(m => m.FeaturesModule),
  },
];

// class CustomUrlSerializer implements UrlSerializer {
//     private defaultUrlSerializer: DefaultUrlSerializer = new DefaultUrlSerializer();

//     serialize(tree: UrlTree): string {
//       // Serialize the URL tree using the default serializer and then replace '%3D' with '='
//       return this.defaultUrlSerializer.serialize(tree).replace(/%3D/g, '=');
//     }

//     parse(url: string): UrlTree {
//       // Parse the URL using the default serializer
//       return this.defaultUrlSerializer.parse(url);
//     }
//   }

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
  providers: [
    // { provide: UrlSerializer, useClass: CustomUrlSerializer }
  ],
})
export class AppRoutingModule {}
